/**
 * Copyright (c) 2022 Schwäbische Werkzeugmaschinen GmbH
 *
 * @author Sebastian Roming
 * @since 5.0.0
 */
import { Route, Router } from '@vaadin/router';
import './components/ld-login-application';

const routes: Route[] = [
  {
    path: '/',
    component: 'ld-login-application',
    children: [
      {
        path: '',
        component: 'login-view',
        action: async () => {
          await import('./views/login/login-view');
        }
      },
      {
        path: 'forgot-password',
        component: 'forgot-password-view',
        action: async () => {
          await import('./views/forgot-password/forgot-password-view');
        }
      },
      {
        path: 'new-password',
        component: 'create-new-password-view',
        action: async () => {
          await import('./views/forgot-password/create-new-password-view');
        }
      },
      {
        path: 'change-password',
        component: 'change-password-view',
        action: async () => {
          await import('./views/change-password/change-password-view');
        }
      }
    ]
  }
];

const outlet        = document.getElementById('ld-login-outlet');
export const router = new Router(outlet);
router.setRoutes(routes);
